<template>
  <div>
    <dropdown-select v-model="buttonType" class="mb-4">
      <option :selected="buttonType === 'bar-button'" value="bar-button">Make Button Entire Bar</option>
      <option :selected="buttonType === 'normal-button'" value="normal-button">Use Button</option>
    </dropdown-select>
    <single-button
      v-if="buttonType === 'normal-button'"
      :button-area-selector="`${getPageSelector} .form-and-buttons`"
      :show-title="false"
      button-class="primary"
    />
    <single-button
      v-if="buttonType === 'bar-button'"
      :button-area-selector="`${getPageSelector}`"
      :inner-editable="false"
      :show-title="false"
      button-class="bar-button"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import SingleButton from "@/components/campaign-builder/content-changers/SingleButton"
import DropdownSelect from "@/components/common/DropdownSelect"

export default {
  name: "Buttons",
  components: { DropdownSelect, SingleButton },
  data() {
    return {
      buttonType: "none"
    }
  },
  watch: {
    buttonType(newValue) {
      console.log(newValue)
      if (newValue === "bar-button") {
        this.getIframeDocuments.forEach((doc) => {
          const primaryButton = doc.querySelector(`${this.getPageSelector} .form-and-buttons button.primary`)
          if (primaryButton) {
            primaryButton.remove()
          }
          const element = doc.querySelector(`${this.getPageSelector} .flat-bar.layout`)
          element.parentElement.innerHTML = `<div class="bar-button">${element.outerHTML}</div>`
        })
      } else if (newValue === "normal-button") {
        this.getIframeDocuments.forEach((doc) => {
          const element = doc.querySelector(`${this.getPageSelector} .bar-button`)
          if (element) {
            element.parentElement.innerHTML = `${element.querySelector(".flat-bar.layout").outerHTML}`
          }
          doc.querySelector(`${this.getPageSelector} .form-and-buttons`).innerHTML = `<button class="primary">Button</button>`
        })
      }
    }
  },
  computed: mapGetters("preview", ["getPageSelector", "getIframeDocuments"]),
  created() {
    if (this.getIframeDocuments[0].querySelector(`${this.getPageSelector} .form-and-buttons button.primary`)) {
      this.buttonType = "normal-button"
    } else {
      this.buttonType = "bar-button"
    }
  }
}
</script>
